"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagParser = void 0;
var BPElementConfig_1 = __importDefault(require("../BPEConfig/BPElementConfig"));
var BPEConfigValidator_1 = __importDefault(require("../BPEConfig/BPEConfigValidator"));
var TagParser = /** @class */ (function () {
    function TagParser(cssSelector) {
        this.cssSelector = cssSelector;
    }
    /**
     * Gets all BPElementConfig from HTML elements
     */
    TagParser.prototype.parse = function () {
        var _this = this;
        var elements = Array.from(document.getElementsByClassName(this.cssSelector));
        return elements
            .map(function (element) { return _this.fillBPElementConfig(element); })
            .filter(function (config) { return BPEConfigValidator_1.default.validate(config); });
    };
    /**
     * Fill BPElementConfig with tag data attributes
     * @param element
     */
    TagParser.prototype.fillBPElementConfig = function (element) {
        var _a, _b, _c, _d;
        var dataAttributes = this.extractDataAttributes(element);
        var elementConfig = new BPElementConfig_1.default();
        elementConfig.type = dataAttributes.get("type");
        elementConfig.width = (_a = dataAttributes.get("width")) !== null && _a !== void 0 ? _a : "";
        elementConfig.height = (_b = dataAttributes.get("height")) !== null && _b !== void 0 ? _b : "";
        elementConfig.appid = (_c = dataAttributes.get("appid")) !== null && _c !== void 0 ? _c : "";
        elementConfig.lang = (_d = dataAttributes.get("lang")) !== null && _d !== void 0 ? _d : "";
        elementConfig.target = element;
        elementConfig.attributes = dataAttributes;
        return elementConfig;
    };
    /**
     * Extract all data attributes
     * @param element
     */
    TagParser.prototype.extractDataAttributes = function (element) {
        var dataAttributes = new Map();
        for (var index = 0; index < element.attributes.length; index++) {
            var attribute = element.attributes[index];
            if (attribute.name.startsWith("data-"))
                dataAttributes.set(attribute.name.replace("data-", ""), attribute.value);
        }
        return dataAttributes;
    };
    return TagParser;
}());
exports.TagParser = TagParser;
exports.default = TagParser;
